import { render } from "./MsgCell.vue?vue&type=template&id=72fb6fa2"
import script from "./MsgCell.vue?vue&type=script&lang=js"
export * from "./MsgCell.vue?vue&type=script&lang=js"

import "./MsgCell.vue?vue&type=style&index=0&id=72fb6fa2&lang=scss"

import exportComponent from "/Users/chenjun/Desktop/myProject/pbl-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__